var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.413086 13.6202C0.445212 13.33 0.472749 13.0398 0.509465 12.7497C0.803193 10.5915 1.73486 8.7416 3.28152 7.1955C4.80064 5.68115 6.63185 4.76528 8.76138 4.42976C9.0138 4.38895 9.2754 4.37535 9.52782 4.34815C9.58749 4.34361 9.65174 4.33455 9.72517 4.32548C9.72517 2.96074 9.72517 1.60507 9.72517 0.213135C12.4926 2.43933 15.2326 4.64286 17.9909 6.86452C15.2372 9.08618 12.4926 11.2988 9.72058 13.534C9.72058 12.1421 9.72058 10.791 9.72058 9.42623C9.07346 9.45344 8.45847 9.54865 7.86184 9.71188C5.13568 10.4691 3.07499 12.0696 1.76699 14.5633C1.30345 15.4474 0.950057 16.3905 0.546181 17.3063C0.509465 17.3925 0.458981 17.4741 0.413086 17.5602C0.413086 16.2454 0.413086 14.935 0.413086 13.6202ZM10.7578 5.34109C8.45388 5.25948 6.40238 5.88971 4.6446 7.33606C2.88223 8.7824 1.85419 10.6459 1.51915 12.9265C3.83685 9.84336 6.89804 8.33354 10.7716 8.38341C10.7716 9.39903 10.7716 10.3738 10.7716 11.3804C12.6487 9.86603 14.5028 8.36981 16.3708 6.86452C14.4982 5.3547 12.6441 3.86754 10.7624 2.35319C10.7578 3.37334 10.7578 4.34361 10.7578 5.34109Z",
    fill: "#29BCC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_3878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.ee92e9aa7b4a975bce4a5e0eba4934ca.svg";
export { ForwardRef as ReactComponent };